<template>
  <div class="loading-container" v-if="loading">
    <img class="loader" src="../assets/logo_slogan_bottom.svg" alt="Logo PortAventura">
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Loading',
  computed: {
    ...mapState(['loading'])
  }
}
</script>

<style>
.loader {
  max-width: 15rem;
}
.loading-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
}
</style>
